import React, { FC, useState, useCallback, useContext } from 'react'
import ItemsCarousel from 'react-items-carousel'
import history from '../../../history'
import { isMobile, isTablet } from 'react-device-detect'
import AppContext from '../../../context/appContext'
import { Modal } from 'react-responsive-modal'
import { activateAlbumAccess } from '../../../Api/backendApi'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import videoAmountIcon from '../../../assets/REDESIGN_Assets/MainScreen/video-amount-icon.svg'
import chalenngeLevelIcon from '../../../assets/REDESIGN_Assets/challenges/miazga_video_level.svg'

import { AiOutlineInfoCircle } from 'react-icons/ai'

import {
  MainPageCarouselBox,
  AlbumCard,
  AlbumName,
  RightArrowButton,
  LeftArrowButton,
  LeftCarouselFadeIn,
  PaidContentBadge,
  AlbumCardBox,
  PurchaseChallengeBox,
  PurchaseChallengeButton,
  UserJoinedBadge,
} from '../styles/MainScreenStyles'

import { getAllAlbumVideos } from '../../../Api/videoApi'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericIcon from '../../../GenericComponents/GenericIcon'
import GenericColumn from '../../../GenericComponents/GenericColumn'
import GenericCard from '../../../GenericComponents/GenericMainCard'
import TimeIcon from '../../../assets/REDESIGN_Assets/AlbumScreen/time-icon.svg'
import GenericCloseButton from '../../../GenericComponents/GenericCloseButton'

import { VideoTile } from '../../ConferencesScreen/styles/ConferencesScreenStyles'
import GenericButton from '../../../GenericComponents/GenericButton'
import { userInfo } from 'os'

interface MainpageCarouselInterface {
  folders: any
  albumType: string
  isDemoMode: boolean | undefined
  albumName: string
  onClick: Function | undefined
  isConferences: boolean
  fullWidth: boolean
  categoryTag: string
  conferencesTrainings: boolean
  setDemoUserRedirectToSubModalOpen: Function | undefined | null
  challengeMode?: boolean
  miazgaPrepare?: boolean
  promoInfo?: any
}

const MainpageCarousel: FC<MainpageCarouselInterface> = ({
  folders,
  albumType,
  isDemoMode,
  albumName,
  onClick,
  isConferences,
  fullWidth,
  categoryTag,
  conferencesTrainings,
  setDemoUserRedirectToSubModalOpen,
  challengeMode,
  miazgaPrepare,
  promoInfo,
}) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const chevronWidth = 40
  const [actualWidth, setActualWidth] = useState(0)
  const appContext = useContext(AppContext)

  const [popupChallengeOpen, setPopupChallengeOpen] = useState(false)
  const [tempFolder, setTempFolder] = useState(null)

  const [isInfoOpen, setInfoOpen] = React.useState(false)
  const [isInfoOpen1, setInfoOpen1] = React.useState(false)

  const [miazga2accessGranted, setMiazga2accessGranted] = React.useState(false)

  const level1 = [
    'Dla osób otyłych',
    'Poziom początkujący',
    'Poziom podstawowy',
  ]

  const level2 = [
    'Dla osób otyłych',
    'Poziom początkujący',
    'Poziom podstawowy',
  ]
  const modalStyles = {
    closeButton: {
      display: 'none',
    },
    modal: {
      maxWidth: 'unset',
      width: isMobile || isTablet ? '95vw' : '45vw',
      overflow: 'unset',
      left: '0',
      boxsizing: 'border-box',
      margin: isMobile || isTablet ? 'auto' : 'unset',
      borderRadius: '30px',
    },
  }

  // const preparedFolders = miazgaPrepare ? folders.albums && folders[0] : folders

  const getFilteredFolders = (category: string) => {
    return (
      folders &&
      folders.albums &&
      folders.albums.filter((album: any) => album.category == category)
    )
  }

  const showChallengePopup = (folder: any) => {
    setTempFolder(folder)
    setPopupChallengeOpen(true)
  }

  const handleActivateAlbumAccess = async (folder: any) => {
    const result = await getAllAlbumVideos(folder.vimeo_album_id, 'nutshell')

    if (result == 402) {
      history.push('wybierz-plan/sub')
    }

    if (result == 425) {
      showChallengePopup(folder)
    }

    if (result == 400 || result == undefined) {
      setMiazga2accessGranted(true)
    }

    if (result == 200) {
      history.push({
        pathname: `/album/${folder.vimeo_album_id}`,
        state: {
          albumName: folder.name,
          albumId: folder.vimeo_album_id,
          seoKeywords: folder.seo_keywords,
          contactEmail: folder.email_address,
          pdfFolder: folder.pdf_folder,
          challengeMode: challengeMode,
        },
      })
    }
  }

  const handlePushUserToMiazgaNutshell = async () => {
    await activateAlbumAccess(tempFolder.vimeo_album_id)

    history.push({
      pathname: `/album/${tempFolder.vimeo_album_id}`,
      state: {
        albumName: tempFolder.name,
        albumId: tempFolder.vimeo_album_id,
        seoKeywords: tempFolder.seo_keywords,
        contactEmail: tempFolder.email_address,
        pdfFolder: tempFolder.pdf_folder,
        challengeMode: challengeMode,
      },
    })
  }

  const isFolderUnlocked = (folder: any) => {
    let isUnlocked: boolean = false

    if (
      (!folder.is_locked &&
        isDemoMode &&
        folder.category == 'MIAZGA W PIGUŁCE') ||
      (!folder.is_locked && isDemoMode && folder.category == 'ZRÓB SZPAGAT') ||
      (isDemoMode && folder.free_content) ||
      (!isDemoMode && !folder.is_locked) ||
      (!isDemoMode && folder.paid_content && !folder.is_locked)
    ) {
      isUnlocked = true
    }

    return isUnlocked
  }

  const properTrainingWord = (trainingAmount: number) => {
    let properWord: string = ''

    if (trainingAmount == 1) {
      properWord = 'film'

      return properWord
    } else if (trainingAmount % 10 >= 2 && trainingAmount % 10 <= 4) {
      properWord = 'filmy'
      return properWord
    } else {
      properWord = 'filmów'
      return properWord
    }
  }

  const shouldMiazgaNutshell2BeOnSale = (folder: any) => {
    let showPaidBadge = false

    if (
      (folder.name == 'Szpagat Turecki' && folder.is_locked) ||
      (folder.name == 'MIAZGA w pigułce' && folder.is_locked) ||
      (folder.name == 'MIAZGA W PIGUŁCE; vol. 2' &&
        folder.is_locked &&
        promoInfo &&
        promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
      (promoInfo &&
        folder.name == 'MIAZGA W PIGUŁCE; vol. 2' &&
        folder.is_locked &&
        promoInfo.promo_status == 'MIAZGA_NUTSHELL_AND_PROMO_DIALOG')
    ) {
      showPaidBadge = true
    }

    return showPaidBadge
  }

  return (
    <MainPageCarouselBox
      className={`${fullWidth && 'full-width'} mainpage-carousel`}
    >
      <GenericTextSpan
        fSize={'1.4rem'}
        display={'block'}
        width={fullWidth ? '100%' : 'unset'}
        tAlign={'left'}
        fWeight={'bold'}
        margin={'1% 0 2% 0%'}
        justify={fullWidth ? 'flex-start' : 'unset'}
        className={`${
          appContext.appState.theme == 'light' ? 'light' : ''
        } link-button`}
      >
        {albumName}
      </GenericTextSpan>
      <div
        style={{
          padding: isMobile ? `5px 30px 10px 30px` : `5px 0px 10px 0px`,
        }}
        className="carousel-container"
      >
        {/* <LeftCarouselFadeIn /> */}
        <ItemsCarousel
          className="direct-carousel-tile"
          id={'car-tile'}
          requestToChangeActive={setActiveItemIndex}
          activeItemIndex={activeItemIndex}
          numberOfCards={
            window.innerWidth < 600 ? 1 : conferencesTrainings ? 2 : 3
          }
          gutter={20}
          // firstAndLastGutter
          showSlither={isMobile ? false : true}
          leftChevron={
            <LeftArrowButton
              className={`${
                appContext.appState.theme == 'light' ? 'light' : ''
              }`}
            />
          }
          infiniteLoop={isMobile ? true : false}
          rightChevron={
            <RightArrowButton
              className={`${
                appContext.appState.theme == 'light' ? 'light' : ''
              }`}
            />
          }
          outsideChevron={true}
          chevronWidth={chevronWidth}
          slidesToScroll={isMobile ? 1 : 2}
        >
          {folders && folders.albums
            ? folders.albums
                .filter((album: any) => album.category == categoryTag)
                .map(
                  (folder: any, i: number) =>
                    ((isConferences && folder.dashboard_order >= 6) ||
                      !isConferences) && (
                      <AlbumCardBox>
                        {/* {folder.user_joined && (
                          <UserJoinedBadge>DOŁĄCZONO</UserJoinedBadge>
                        )} */}

                        <AlbumCard
                          onClick={
                            onClick !== undefined && isFolderUnlocked(folder)
                              ? () => onClick(folder)
                              : () =>
                                  isFolderUnlocked(folder)
                                    ? folder.name.includes('PIGU') ||
                                      folder.name.includes('pigu')
                                      ? handleActivateAlbumAccess(folder)
                                      : history.push({
                                          pathname: `/album/${folder.vimeo_album_id}`,
                                          state: {
                                            albumName: folder.name,
                                            albumId: folder.vimeo_album_id,
                                            seoKeywords: folder.seo_keywords,
                                            contactEmail: folder.email_address,
                                            pdfFolder: folder.pdf_folder,
                                            challengeMode: challengeMode,
                                          },
                                        })
                                    : isDemoMode && !folder.free_content
                                    ? setDemoUserRedirectToSubModalOpen(true)
                                    : folder.name == 'MIAZGA w pigułce' &&
                                      handleActivateAlbumAccess(folder)
                          }
                          className={`${
                            isFolderUnlocked(folder) && 'active'
                          } carousel-album-tile`}
                          src={
                            challengeMode
                              ? folder.pictures.sizes[1].link
                              : folder.pictures.sizes[3].link
                          }
                        >
                          <AlbumName
                            className={`${
                              appContext.appState.theme == 'light'
                                ? 'light'
                                : ''
                            } link-button`}
                          >
                            {folder.name.includes(';') ||
                            folder.name == 'MIAZGA w pigułce' ? (
                              <div>
                                <GenericTextSpan
                                  // className={`${
                                  //   appContext.appState.theme == 'light'
                                  //     ? 'light'
                                  //     : ''
                                  // }`}
                                  tAlign="left"
                                  display={'block'}
                                  width={'100%'}
                                  fSize={isMobile ? '1.2rem' : '1.3rem'}
                                  fWeight={'bold'}
                                >
                                  {folder.name.includes(';')
                                    ? folder.name.split(';')[0]
                                    : 'MIAZGA W PIGUŁCE'}
                                  {/* {folder.name == 'MIAZGA w pigułce' && (
                                    <div className="new-badge-mainscreen">
                                      <span>Nowość</span>
                                    </div>
                                  )} */}
                                </GenericTextSpan>
                                <GenericTextSpan
                                  // className={`${
                                  //   appContext.appState.theme == 'light'
                                  //     ? 'light'
                                  //     : ''
                                  // }`}
                                  tAlign="left"
                                  display={'block'}
                                  width={'100%'}
                                  fSize={isMobile ? '1rem' : '0.9rem'}
                                >
                                  {folder.name.includes('vol. 2')
                                    ? 'Program 3 miesiące, vol. 2'
                                    : folder.name.includes(';')
                                    ? folder.name.split(';')[1]
                                    : 'Program 3 miesiące, vol. 1'}
                                </GenericTextSpan>
                              </div>
                            ) : (
                              <GenericTextSpan
                                // className={`${
                                //   appContext.appState.theme == 'light'
                                //     ? 'light'
                                //     : ''
                                // }`}
                                tAlign="left"
                                fSize={isMobile ? '1.2rem' : '1.3rem'}
                                fWeight={'bold'}
                                display={'block'}
                                width={'100%'}
                              >
                                {folder.name}
                              </GenericTextSpan>
                            )}
                          </AlbumName>

                          <GenericRow
                            margin={'5% 0 0 0'}
                            align={isMobile ? 'self-end' : 'end'}
                            justify="flex-start"
                          >
                            <GenericIcon
                              src={videoAmountIcon}
                              width={
                                isMobile && !isTablet
                                  ? '2.8vw'
                                  : isTablet
                                  ? '1.4vw'
                                  : '0.8vw'
                              }
                              height={
                                isMobile && !isTablet
                                  ? '2.8vw'
                                  : isTablet
                                  ? '1.4vw'
                                  : '0.8vw'
                              }
                            />
                            <GenericTextSpan
                              margin={'0 0 0 1%'}
                              fSize={isMobile ? '0.8rem' : '0.8rem'}
                              // className={`${
                              //   appContext.appState.theme == 'light'
                              //     ? 'light'
                              //     : ''
                              // }`}
                            >
                              {' '}
                              {folder && folder.video_count}{' '}
                              {properTrainingWord(folder.video_count)}
                            </GenericTextSpan>
                          </GenericRow>

                          {folder && folder.difficulty_level && (
                            <GenericRow
                              margin={'3% 0 0 0'}
                              align={isMobile ? 'self-end' : 'end'}
                              justify="flex-start"
                            >
                              <GenericIcon
                                src={chalenngeLevelIcon}
                                width={
                                  isMobile && !isTablet
                                    ? '2.8vw'
                                    : isTablet
                                    ? '1.4vw'
                                    : '0.8vw'
                                }
                                height={
                                  isMobile && !isTablet
                                    ? '2.8vw'
                                    : isTablet
                                    ? '1.4vw'
                                    : '0.8vw'
                                }
                              />
                              <GenericTextSpan
                                margin={'0 0 0 1%'}
                                fSize={isMobile ? '0.8rem' : '0.8rem'}
                                // className={`${
                                //   appContext.appState.theme == 'light'
                                //     ? 'light'
                                //     : ''
                                // }`}
                              >
                                {folder && folder.difficulty_level}
                              </GenericTextSpan>
                            </GenericRow>
                          )}
                        </AlbumCard>

                        {folder.name.includes('pigu') &&
                        !folder.name.includes('vol. 2') ? (
                          <GenericRow
                            position={'absolute'}
                            justify="end"
                            zIndex={11}
                            right={'10px'}
                            // onClick={() => setInfoOpen(true)}
                            margin={'3% 0'}
                            color={'#a1ff68'}
                            fSize={'1.5rem'}
                          >
                            <AiOutlineInfoCircle
                              onClick={() => setInfoOpen(true)}
                              // className="miazga-info"
                            />
                            {/* <GenericTextSpan
                              margin={'0% 0 0 1%'}
                              tAlign={'left'}
                              width={'100%'}
                              fSize={'1rem'}
                              color={'#a1ff68'}
                              fWeight="bold"
                              onClick={() => setInfoOpen1(true)}
                            >
                              Sprzęt potrzebny do ćwiczeń
                            </GenericTextSpan> */}
                            {/*
                            {isInfoOpen && (
                              <div className="miazga-nutshell-info nutshell mainpage">
                                <GenericCloseButton
                                  className="promo-modal-close-btn info "
                                  width={'14px'}
                                  height={'14px'}
                                  onClick={() => setInfoOpen(false)}
                                />
                                <GenericTextSpan
                                  display={'block'}
                                  fSize={'1rem'}
                                  fWeight="bold"
                                  color={'white'}
                                  tAlign={'center'}
                                >
                                  Potrzebny sprzęt:
                                </GenericTextSpan>

                                <ul className="need-items">
                                  <li>hantle</li>
                                  <li>gumy</li>
                                  <li>hip band</li>
                                  <li>mata</li>
                                  <li>krzesło</li>
                                </ul>
                              </div>
                            )} */}
                          </GenericRow>
                        ) : (
                          folder.name.includes('vol. 2') && (
                            <GenericRow
                              position={'absolute'}
                              justify="end"
                              zIndex={11}
                              right={'10px'}
                              // onClick={() => setInfoOpen(true)}
                              margin={'3% 0'}
                              color={'#a1ff68'}
                              fSize={'1.5rem'}
                            >
                              <AiOutlineInfoCircle
                                onClick={() => setInfoOpen1(true)}
                                // className="miazga-info"
                              />
                              {/* <GenericTextSpan
                          margin={'0% 0 0 1%'}
                          tAlign={'left'}
                          width={'100%'}
                          fSize={'1rem'}
                          color={'#a1ff68'}
                          fWeight="bold"
                          onClick={() => setInfoOpen1(true)}
                        >
                          Sprzęt potrzebny do ćwiczeń
                        </GenericTextSpan> */}
                            </GenericRow>
                          )
                        )}

                        {shouldMiazgaNutshell2BeOnSale(folder) ? (
                          <PaidContentBadge
                            onClick={() =>
                              folder.name.includes('Szpag')
                                ? history.push({
                                    pathname: `/wybierz-plan/${folder.name}`,
                                  })
                                : history.push({
                                    pathname: `/wybierz-plan/sub`,
                                    state: {
                                      mode: 'w-pigulce',
                                      version: folder.name,
                                    },
                                  })
                            }
                          >
                            Wykup dostęp
                          </PaidContentBadge>
                        ) : challengeMode && folder.is_locked ? (
                          <PurchaseChallengeBox
                            onClick={() =>
                              history.push({
                                pathname: '/wyzwania/kup-pakiet',
                                state: { productId: folder.vimeo_album_id },
                              })
                            }
                          >
                            <PurchaseChallengeButton>
                              <GenericTextSpan fWeight="bold" fSize="1.3rem">
                                Wykup
                              </GenericTextSpan>
                              {/* <GenericTextSpan margin="0 2px 0 5px" fSize="1.3rem" color="#a1ff68">9,99</GenericTextSpan>
                            <GenericTextSpan margin="4px 0 0 0" fSize="0.6rem" color="#a1ff68">zł</GenericTextSpan> */}
                            </PurchaseChallengeButton>
                          </PurchaseChallengeBox>
                        ) : null}
                      </AlbumCardBox>
                    )
                )
            : folders &&
              folders.map(
                (folder: any) =>
                  ((isConferences && categoryTag == 'TRENINGI MIAZGA') ||
                    !isConferences) &&
                  (!isConferences ? (
                    <AlbumCard
                      onClick={
                        onClick !== undefined && isFolderUnlocked(folder)
                          ? () => onClick(folder)
                          : () =>
                              isFolderUnlocked(folder)
                                ? history.push({
                                    pathname: `/album/${folder.vimeo_album_id}`,
                                    state: { albumName: folder.name },
                                  })
                                : isDemoMode &&
                                  !folder.free_content &&
                                  setDemoUserRedirectToSubModalOpen(true)
                      }
                      className={`${
                        isFolderUnlocked(folder) && 'active'
                      } carousel-album-tile`}
                      src={folder.pictures.sizes[3].link}
                    >
                      <AlbumName
                        className={`${
                          appContext.appState.theme == 'light' ? 'light' : ''
                        } link-button`}
                      >
                        {folder.name}
                      </AlbumName>
                    </AlbumCard>
                  ) : (
                    <VideoTile
                      onClick={folder.is_locked ? null : () => onClick(folder)}
                      className={folder.is_locked ? 'inactive' : ''}
                    >
                      <GenericColumn
                        width={'26%'}
                        height={'96%'}
                        margin={'0 0 0 4%'}
                      >
                        <GenericIcon
                          backgroundSize={'cover'}
                          width={'100%'}
                          height={'80%'}
                          borderRadius={'19px'}
                          src={
                            folder &&
                            folder.pictures &&
                            folder.pictures.sizes[3].link
                          }
                        ></GenericIcon>
                      </GenericColumn>
                      <GenericColumn
                        width={'70%'}
                        height={'100%'}
                        justify="space-between"
                        padding={'5%'}
                      >
                        <GenericRow justify={'flex-start'} align={'baseline'}>
                          <GenericTextSpan fSize={'0.8rem'}></GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify={'flex-start'} align={'baseline'}>
                          <GenericTextSpan fSize={'1.1rem'} fWeight={'bold'}>
                            {folder && folder.name}
                          </GenericTextSpan>
                        </GenericRow>
                        <GenericRow justify={'flex-start'} align={'baseline'}>
                          <GenericIcon
                            margin={'0 5px 0 0'}
                            width={'0.8rem'}
                            height={'0.8rem'}
                            src={TimeIcon}
                          ></GenericIcon>
                          <GenericTextSpan fSize={'0.9rem'}>
                            {folder &&
                              Math.floor(folder.duration / 60) + 'minut'}
                          </GenericTextSpan>
                        </GenericRow>
                      </GenericColumn>
                    </VideoTile>
                  ))
              )}
          {/* <div style={{ height: 200, background: '#EEE' }}>First card</div>
          <div style={{ height: 200, background: '#EEE' }}>Second card</div>
          <div style={{ height: 200, background: '#EEE' }}>Third card</div>
          <div style={{ height: 200, background: '#EEE' }}>Fourth card</div> */}
          <Modal
            open={
              popupChallengeOpen ||
              isInfoOpen1 ||
              isInfoOpen ||
              miazga2accessGranted
            }
            animationDuration={700}
            onClose={() =>
              isInfoOpen1
                ? setInfoOpen1(false)
                : isInfoOpen
                ? setInfoOpen(false)
                : miazga2accessGranted
                ? setMiazga2accessGranted(false)
                : setPopupChallengeOpen(false)
            }
            center
            styles={modalStyles}
          >
            {(popupChallengeOpen ||
              isInfoOpen1 ||
              isInfoOpen ||
              miazga2accessGranted) && (
              <GenericCard className="promo-modal">
                <GenericCloseButton
                  top={'7%'}
                  right={'4%'}
                  className="promo-modal-close-btn"
                  onClick={() =>
                    isInfoOpen1
                      ? setInfoOpen1(false)
                      : isInfoOpen
                      ? setInfoOpen(false)
                      : miazga2accessGranted
                      ? setMiazga2accessGranted(false)
                      : setPopupChallengeOpen(false)
                  }
                />
                <GenericColumn>
                  <GenericRow margin={'3% 0 3% 0'}>
                    <GenericTextSpan
                      className="accent-color"
                      fSize={window.innerWidth < 1400 ? '2rem' : '2.2rem'}
                      fWeight={'bold'}
                    >
                      {isInfoOpen1 || isInfoOpen
                        ? `Potrzebny sprzęt ${
                            isInfoOpen1
                              ? 'do MIAZGI vol. 2'
                              : 'do MIAZGI vol. 1'
                          }:`
                        : miazga2accessGranted
                        ? 'Dostęp do MIAZGI W PIGUŁCE'
                        : 'Dostęp do MIAZGI W PIGUŁCE'}
                    </GenericTextSpan>
                  </GenericRow>
                  {!isInfoOpen1 && !isInfoOpen && !miazga2accessGranted && (
                    <GenericRow margin={'0% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        {tempFolder && tempFolder.name.includes('vol. 2')
                          ? 'Zakupiłaś dostęp do '
                          : ' Zakupiłaś dostęp do '}

                        <b>
                          {tempFolder && tempFolder.name.includes('vol. 2')
                            ? 'MIAZGI W PIGUŁCE vol. 2'
                            : 'MIAZGI W PIGUŁCE'}
                        </b>
                      </GenericTextSpan>
                    </GenericRow>
                  )}

                  {miazga2accessGranted && (
                    <GenericRow margin={'0% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        Pomyślnie aktywowano pakiet.
                      </GenericTextSpan>
                    </GenericRow>
                  )}

                  {!isInfoOpen1 && !isInfoOpen && (
                    <GenericRow margin={'2% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                        className="accent-color"
                      ></GenericTextSpan>
                    </GenericRow>
                  )}

                  {!isInfoOpen1 &&
                    !isInfoOpen &&
                    tempFolder &&
                    !tempFolder.name.includes('vol. 2') && (
                      <GenericRow margin={'1% 0 1% 0'}>
                        <GenericTextSpan
                          fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                          fWeight={'bold'}
                        >
                          Aktywuj go, aby uzyskać do niego dostęp.
                          <b>
                            Po aktywacji Twój dostęp będzie ważny przez 3
                            miesiące.
                          </b>
                        </GenericTextSpan>
                      </GenericRow>
                    )}

                  {!isInfoOpen1 &&
                    !isInfoOpen &&
                    tempFolder &&
                    tempFolder.name.includes('vol. 2') && (
                      <GenericRow margin={'1% 0 1% 0'}>
                        <GenericTextSpan
                          fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                          fWeight={'bold'}
                        >
                          Aktywuj go, aby uzyskać do niego dostęp. Po aktywacji
                          Twój dostęp będzie ważny przez 3 miesiące.
                        </GenericTextSpan>
                      </GenericRow>
                    )}
                  {!isInfoOpen1 && !isInfoOpen && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        <GenericButton
                          onClick={() => handlePushUserToMiazgaNutshell()}
                          className="standard"
                        >
                          Aktywuj
                        </GenericButton>
                      </GenericTextSpan>
                    </GenericRow>
                  )}

                  {isInfoOpen1 && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        hantle
                      </GenericTextSpan>
                    </GenericRow>
                  )}
                  {isInfoOpen1 && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        mata
                      </GenericTextSpan>
                    </GenericRow>
                  )}
                  {isInfoOpen1 && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        duża piłka do ćwiczeń
                      </GenericTextSpan>
                    </GenericRow>
                  )}
                  {isInfoOpen1 && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        gumy hip band
                      </GenericTextSpan>
                    </GenericRow>
                  )}
                  {isInfoOpen1 && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        pas neoprenowy (nieobowiązkowe)
                      </GenericTextSpan>
                    </GenericRow>
                  )}

                  {isInfoOpen && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        hantle
                      </GenericTextSpan>
                    </GenericRow>
                  )}
                  {isInfoOpen && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        gumy
                      </GenericTextSpan>
                    </GenericRow>
                  )}
                  {isInfoOpen && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        hip band
                      </GenericTextSpan>
                    </GenericRow>
                  )}
                  {isInfoOpen && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        mata
                      </GenericTextSpan>
                    </GenericRow>
                  )}

                  {isInfoOpen && (
                    <GenericRow margin={'4% 0 1% 0'}>
                      <GenericTextSpan
                        fSize={window.innerWidth < 1400 ? '1.4rem' : '1.7rem'}
                        fWeight={'bold'}
                      >
                        krzesło
                      </GenericTextSpan>
                    </GenericRow>
                  )}
                </GenericColumn>
              </GenericCard>
            )}
          </Modal>
        </ItemsCarousel>
      </div>
    </MainPageCarouselBox>
  )
}

export default MainpageCarousel
